import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6cc33e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-mb-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "ql-bold" }),
  /*#__PURE__*/_createElementVNode("button", { class: "ql-italic" }),
  /*#__PURE__*/_createElementVNode("button", { class: "ql-underline" }),
  /*#__PURE__*/_createElementVNode("button", { class: "ql-strike" }),
  /*#__PURE__*/_createElementVNode("button", { class: "ql-code-block" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "info-messages" }
const _hoisted_6 = { class: "quick-messages" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Editor, {
        placeholder: _ctx.label,
        class: _normalizeClass(['p-mt-3', { 'p-invalid': _ctx.error }]),
        modelValue: _ctx.modelValue,
        onTextChange: _ctx.change,
        editorStyle: "height: 100px"
      }, {
        toolbar: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["placeholder", "class", "modelValue", "onTextChange"]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.QuickMessages.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t("inputeditor.quickmessages.title")), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QuickMessages, (message, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `qm-${index}`,
                  class: "message",
                  onClick: () => _ctx.selectMessage(message)
                }, _toDisplayString(message), 9, _hoisted_7))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}